"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var SmoothScroll = /** @class */ (function () {
    function SmoothScroll($smoothScroll, $timeout) {
        var _this = this;
        this.$smoothScroll = $smoothScroll;
        this.$timeout = $timeout;
        this.restrict = 'A';
        this.scope = {
            callbackBefore: '&',
            callbackAfter: '&',
        };
        this.link = function ($scope, $element, $attrs) {
            if (typeof $attrs.scrollIf === 'undefined' || $attrs.scrollIf === 'true') {
                _this.$timeout(function () {
                    var callbackBefore = function (element) {
                        if ($attrs.callbackBefore) {
                            var exprHandler = $scope.callbackBefore({ element: element });
                            if (typeof exprHandler === 'function') {
                                exprHandler(element);
                            }
                        }
                    };
                    var callbackAfter = function (element) {
                        if ($attrs.callbackAfter) {
                            var exprHandler = $scope.callbackAfter({ element: element });
                            if (typeof exprHandler === 'function') {
                                exprHandler(element);
                            }
                        }
                    };
                    _this.$smoothScroll($element[0], {
                        duration: $attrs.duration,
                        offset: $attrs.offset,
                        easing: $attrs.easing,
                        callbackBefore: callbackBefore,
                        callbackAfter: callbackAfter,
                        containerId: $attrs.containerId
                    });
                }, 0);
            }
        };
    }
    return SmoothScroll;
}());
exports.SmoothScroll = SmoothScroll;
var ScrollTo = /** @class */ (function () {
    function ScrollTo($smoothScroll, $timeout) {
        var _this = this;
        this.$smoothScroll = $smoothScroll;
        this.$timeout = $timeout;
        this.restrict = 'A';
        this.scope = {
            callbackBefore: '&',
            callbackAfter: '&',
        };
        this.link = function ($scope, $element, $attrs) {
            var targetElement;
            var scrollTo = function () {
                targetElement = document.getElementById($attrs.scrollTo);
                if (!targetElement)
                    return;
                var callbackBefore = function (element) {
                    if ($attrs.callbackBefore) {
                        var exprHandler = $scope.callbackBefore({ element: element });
                        if (typeof exprHandler === 'function') {
                            exprHandler(element);
                        }
                    }
                };
                var callbackAfter = function (element) {
                    if ($attrs.callbackAfter) {
                        var exprHandler = $scope.callbackAfter({ element: element });
                        if (typeof exprHandler === 'function') {
                            exprHandler(element);
                        }
                    }
                };
                _this.$smoothScroll(targetElement, {
                    duration: $attrs.duration,
                    offset: parseInt($attrs.offset, 10),
                    easing: $attrs.easing,
                    callbackBefore: callbackBefore,
                    callbackAfter: callbackAfter,
                    containerId: $attrs.containerId
                });
            };
            $element.on('click', function (e) {
                e.preventDefault();
                if ($attrs.scrollTimeout) {
                    _this.$timeout(function () {
                        scrollTo();
                    }, $attrs.scrollTimeout);
                }
                else {
                    scrollTo();
                }
            });
        };
    }
    ScrollTo.create = function ($smoothScroll, $timeOut) {
        return new ScrollTo($smoothScroll, $timeOut);
    };
    return ScrollTo;
}());
exports.ScrollTo = ScrollTo;
//# sourceMappingURL=data:application/json;base64,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